import { render, staticRenderFns } from "./OrderDetailList.vue?vue&type=template&id=7b8a9c82&"
import script from "./OrderDetailList.vue?vue&type=script&lang=js&"
export * from "./OrderDetailList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports